import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoReferenceMaterialImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 182,
	height: 115,
	viewBox: "0 0 182 115",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M127.744 101.351L62.571 113.334C61.6107 113.511 60.62 113.297 59.8168 112.739C59.0136 112.181 58.4638 111.325 58.2882 110.36L43.7217 30.2684C43.5461 29.3029 43.7591 28.3067 44.314 27.4992C44.8688 26.6916 45.72 26.1387 46.6803 25.9621L90.1289 17.9734L120.109 38.7968L130.703 97.0449C130.878 98.0104 130.665 99.0065 130.11 99.8141C129.555 100.622 128.704 101.175 127.744 101.351Z",
			fill: "#FBFBFB",
			stroke: "#CFCFCF",
			strokeWidth: 2.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.054 105.095H69.7999C68.8237 105.095 67.8875 104.705 67.1972 104.011C66.5069 103.317 66.1191 102.376 66.1191 101.394V19.9747C66.1191 18.9932 66.5069 18.0518 67.1972 17.3578C67.8875 16.6637 68.8237 16.2738 69.7999 16.2738H113.969L139.734 42.18V101.394C139.734 102.376 139.347 103.317 138.656 104.011C137.966 104.705 137.03 105.095 136.054 105.095Z",
			fill: "#FBFBFB",
			stroke: "#CFCFCF",
			strokeWidth: 2.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.129 16.2738V44.0304H139.735",
			stroke: "#CFCFCF",
			strokeWidth: 2.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130 20.5629C135.889 22.6886 149.389 25.6644 156.275 20.5629C163.161 15.4614 165.335 9.17563 162.164 4.62065C160.503 2.79868 155.514 -0.231024 151.292 4.62065C148.121 8.26454 149.027 13.0299 153.104 15.5526C158.993 19.1964 171.134 18.1032 179.832 4.62065",
			stroke: "#CFCFCF",
			strokeWidth: 2.8,
			strokeLinecap: "round"
		})
	]
});
export default SvgNoReferenceMaterialImage;
